export const UNANNOTATED_TERM_NAME = "Not on global network";
